/*
 * @Author: your name
 * @Date: 2021-07-15 12:33:44
 * @LastEditTime: 2021-07-16 09:33:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \shop_saas\src\elearningservice\repository\invList.ts
 */
import {idxBasic} from '@/library2/basicClass/idxBasic.js'
import DB from '@/elearningservice/repository/DB.js'
import {tick} from '@/elearningservice/repository/tick.js'

export class invList extends idxBasic {
	_tkey = 'MemTickInfo.orderTick'

	constructor() {
		super(DB)
		this._mySetParam()
	}

	_mySetParam() {
		super.setTable('invList')
	}

	async _getTickInfo() {
		let obj = new tick()
		let tickInfo = await obj.get(false)
		if(! tickInfo) return false

		return eval('tickInfo.' + this._tkey)
	}
}

